// extracted by mini-css-extract-plugin
export var linkText = "_rc-0";